import {useCustomApi} from '_customHooks'
/**
 * @name useResetPassword
 *
 * @description
 * Custom hook for managing reset password.
 *
 * @hook
 * @param {Object} props - The properties object.
 * @param {string} [props.locale] - The locale ID of customer navigation.
 *
 * @returns {Object} An object containing the succes message, error.
 */

const useResetPassword = (locale) => {
    const {useResetPassword} = useCustomApi()
    const resetPasswordFlow = useResetPassword(locale)

    const executeResetPasswordFlow = async (loginEmail) => {
        try {
            const resetResponse = await resetPasswordFlow.mutateAsync({loginEmail})

            return resetResponse
        } catch (error) {
            console.error('Error during reset password flow:', error)
            throw error
        }
    }

    return {executeResetPasswordFlow}
}

export {useResetPassword}
